module.exports = __webpack_public_path__ + "img/icon31.5658f1fd.png";